export const currencyFormatted = (
  number: string | number,
  options: Intl.NumberFormatOptions | undefined = {
    style: 'currency',
    currency: 'EUR',
  },
  locales: string | string[] = 'de-DE'
) => {
  if (typeof number === 'string') {
    const parsedNumber = parseFloat(number)
    if (!isNaN(parsedNumber)) {
      number = parsedNumber
    } else {
      return 'Invalid Number'
    }
  }

  return new Intl.NumberFormat(locales, options).format(number)
}

export const decimalFormatted = (
  value: string | number | undefined | null,
  decimalPlaces: undefined | number = 2
) => {
  if (!value) {
    return '0'
  }
  const numberValue = typeof value === 'string' ? parseFloat(value) : value
  if (!isNaN(numberValue) && isFinite(numberValue)) {
    const roundedValue = parseFloat(numberValue.toFixed(decimalPlaces))
    return roundedValue.toString()
  } else {
    return 'Invalid Number'
  }
}

export const dateFormatted = (
  date: Date | string | null,
  options: Intl.DateTimeFormatOptions | undefined = {
    dateStyle: 'long',
  },
  locales: string | string[] = 'de-DE'
) => {
  if (!date) return ''
  if (typeof date === 'string') {
    date = new Date(date)
    if (isNaN(date.getTime())) {
      return 'Invalid Date'
    }
  }

  return new Intl.DateTimeFormat(locales, options).format(date)
}

export const parseGermanDate = (germanDateString: string) => {
  const [day, month, year] = germanDateString.split('.').map(Number)

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    throw new Error('Invalid date format. Expected "dd.mm.yyyy".')
  }

  // Create a date string in the format "yyyy-mm-dd"
  const isoDateString = `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}`

  return isoDateString
}

const germanNumberFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const formatGermanNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value)) {
    return ''
  }
  return germanNumberFormatter.format(value)
}

export const parseGermanNumber = (value: string): number | undefined => {
  if (!value || value.trim() === '') {
    return undefined
  }

  const cleaned = value.replace(/\./g, '').replace(/,/g, '.')

  const parsed = parseFloat(cleaned)
  if (isNaN(parsed)) {
    return undefined
  }

  return parsed
}
